<template>
  <main role="main" class="d-flex flex-column" style="min-height:100vh">

    <div style="flex:1 1 auto" :class="getBackgroundUiClass()">
      
      <!-- Navigation -->
      <page-header nav="1"></page-header>

        <!-- Body -->
        <div class="container my-5" :class="getBackgroundUiClass()">
          <div class="row">
            <div class="col lead">

              <p class="lead"><span class="font-weight-bold ">PCB Preflight</span> is an online platform built to verify and prepare PCB designs are ready for manufacturing. <b>Available on PC (Windows, Linux, Apple), iOS (iPhone, iPads) and Android devices.</b></p>            
              
              <!-- Movie -->
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://numericalsoftware-update.s3.us-east-1.amazonaws.com/tutorials/PCB%20Preflight%20Intro.mp4"
                allowfullscreen>
              </b-embed>              
              
              <p class="lead mb-3">Adding PCB Preflight to your design flow, will result in improved PCB Manufacturability for your prototypes and NPIs, faster Delivery times and lower overall costs!</p>            
              <h5  class="mt-4 mb-1 ">PCB Preflight has 2 primary solutions: Online PCB Analysis and API automation</h5>
              <ul>
                <li><b class="">PCB Analysis/CAM tools</b> (Design Analysis + PCB PreCAM + Panelization)</li>
                <li><b class="">API Automation</b> (Signup today) </li>
              </ul>              
              <hr class="my-4"/>
              <router-link tag="button" class="btn btn-lg btn-primary mt-5" :to="{name:'Signup'}">Get started for free</router-link>

            </div>
          </div>
        </div>

      <!-- Footer -->
      <page-footer></page-footer>

    </div>

  </main>
</template>

<style>
  /* TOOLBAR BUTTON COLORS*/
  .black-toolbar-ui {
    color: white;
    background-color:rgba(59, 67, 82,1.0) !important;
  }

  .black-pane-ui {
    color: white;
    background-color:rgba(82, 87, 92,1.0) !important;
  }

  .white-toolbar-ui {
    color: #343a40;
    background-color:#6c757d55 !important;
  }

  .white-pane-ui {
    color: #343a40;
    background-color:#f8f9fa !important;
  }
</style>

<script>
  import PageHeader from '../components/PageHeader.vue';
  import PageFooter from '../components/PageFooter.vue';
  import Common from '../mixins/Common'

  export default {

    mixins: [Common],

    components: {PageHeader,PageFooter},
    
    //--------------------------------------------------------------------//

    data() 
    {
      return {
        bTouchDevice: false,
        moment,
        bgcolor: '#202329',
        resultJobs: null,
        bDashboardThemeDarkMode: true,  //Force Dark mode for now
      }
    },

    mounted() {
      app = this;
      document.title = 'Solutions';
    },

    methods: {

    //--------------------------------------------------------------------//

    getBackgroundUiClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'white-toolbar-ui';
      }
      else 
      {
        return 'black-toolbar-ui';
      }
    },

    //--------------------------------------------------------------------//
    
    getBackgroundPaneClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'white-pane-ui';
      }
      else 
      {
        return 'black-pane-ui';
      }
    },

    //--------------------------------------------------------------------//
    
    getTextUiClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'text-dark bg-light';
      }
      else 
      {
        return 'text-light bg-dark';
      }
    },

    //--------------------------------------------------------------------//
    
    getBorderUIClass() 
    {
      if( !this.bDashboardThemeDarkMode ) 
      {
        return 'text-dark bg-light border-light';
      }
      else 
      {
        return 'text-light bg-secondary border-secondary';
      }
    },

    }

  }
</script>
